<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
  import { clone, filter, find, isEqual, isUndefined, isEmpty } from 'lodash'

  export default {
    name: 'MultiSelectInput',
    props: {
      showSearch: {
        type: Boolean,
        default: false,
      },
      searchAsync: {
        type: Boolean,
        default: false,
      },
      items: {
        type: Array,
      },
      label: {
        type: String,
      },
      itemKey: {
        type: String,
      },
      itemValue: {
        type: String,
      },
      results: {
        type: Array,
        default: _ => [],
      },
    },
    data() {
      return {
        res: [],
        search: '',
        searchItems: [],
      }
    },
    watch: {
      results() {
        this.res = clone(this.results)
      },
      items: {
        handler() {
          this.setSearchItems(false)
        },
        immediate: true,
      },
      search() {
        setTimeout(() => {
          if (this.searchAsync) {
            this.$emit('onAsyncSearch', this.search)
          } else {
            this.setSearchItems()
          }
        }, 500)
      },
    },
    created() {
      if (this.results) {
        this.res = this.results
      }
    },
    methods: {
      setSearchItems(filterItems = true) {
        if (this.showSearch) {
          if (!this.searchAsync && !isEmpty(this.search)) {
            return this.searchItems = filter(this.items, i => {
              return i[this.itemValue].toLowerCase().includes(this.search.toLowerCase())
            })
          }
        }
        this.searchItems = this.items
      },
      isItemActive(item) {
        return !isUndefined(find(this.results, i => isEqual(i, item)))
      },
      toggleItem(item) {
        const itemIndex = this.res.indexOf(find(this.results, i => isEqual(i, item)))
        itemIndex >= 0 ? this.$delete(this.res, itemIndex) : this.res.push(item)
        this.$emit('resultsUpdated', this.res)
      },
      removeItem(index) {
        this.$delete(this.res, index)
        this.$emit('resultsUpdated', this.res)
      },
    },
  }
</script>
